import { motion } from "framer-motion";
import { Boxes, ClipboardCheck, Users } from "lucide-react";
import { Reveal } from "./Reveal";

const NODES = [
  { id: "stock", name: "Stock", color: "#22C55E", Icon: Boxes, pos: "left-1/2 top-0 -translate-x-1/2", duration: 5 },
  { id: "calidad", name: "Calidad", color: "#3B82F6", Icon: ClipboardCheck, pos: "left-[2%] bottom-[4%]", duration: 6 },
  { id: "personas", name: "Personas", color: "#F59E0B", Icon: Users, pos: "right-[2%] bottom-[4%]", duration: 5.5 },
];

const Node = ({ name, color, Icon, duration, testId }) => (
  <motion.div
    data-testid={testId}
    animate={{ y: [0, -8, 0] }}
    transition={{ duration, repeat: Infinity, ease: "easeInOut" }}
    className="flex items-center gap-3 rounded-2xl border border-[#1F3D35]/8 bg-white px-5 py-4 shadow-[0_16px_40px_rgba(15,77,63,0.10)]"
  >
    <span className="flex h-10 w-10 items-center justify-center rounded-xl" style={{ backgroundColor: `${color}1A`, color }}>
      <Icon size={19} strokeWidth={1.9} />
    </span>
    <span className="text-sm font-semibold text-[#1F3D35]">TUPU {name}</span>
  </motion.div>
);

export const Ecosystem = () => (
  <section id="ecosistema" data-testid="ecosystem-section" className="overflow-hidden py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal className="text-center">
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.22em] text-[#0F4D3F]/60">Ecosistema</p>
        <h2 className="mx-auto max-w-2xl text-4xl font-medium tracking-tight text-[#1F3D35] md:text-5xl" data-testid="ecosystem-title">
          Productos separados. Una misma plataforma.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base font-light leading-relaxed text-[#1F3D35]/70 md:text-lg">
          Cada solución funciona por sí sola y todas comparten el mismo ecosistema TUPU.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="relative mx-auto mt-8 hidden h-[440px] max-w-3xl md:block" data-testid="ecosystem-diagram">
          <svg aria-hidden className="absolute inset-0 h-full w-full" viewBox="0 0 768 440" fill="none">
            <line x1="384" y1="220" x2="384" y2="52" stroke="#0F4D3F" strokeOpacity="0.35" strokeWidth="2" className="animate-dash" />
            <line x1="384" y1="220" x2="96" y2="392" stroke="#0F4D3F" strokeOpacity="0.35" strokeWidth="2" className="animate-dash" />
            <line x1="384" y1="220" x2="672" y2="392" stroke="#0F4D3F" strokeOpacity="0.35" strokeWidth="2" className="animate-dash" />
          </svg>

          <motion.div
            data-testid="ecosystem-core"
            animate={{ scale: [1, 1.04, 1] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            className="absolute left-1/2 top-1/2 flex h-32 w-32 -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-[2rem] bg-[#0F4D3F] shadow-[0_24px_64px_rgba(15,77,63,0.35)]"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#C6F04A] p-2.5">
              <img src="/t-dark.png" alt="" className="h-full w-auto" />
            </span>
            <span className="mt-2 text-sm font-extrabold tracking-[0.2em] text-[#F3EBD7]">TUPU</span>
          </motion.div>

          <div aria-hidden className="absolute left-1/2 top-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 animate-ping rounded-[2rem] bg-[#C6F04A]/20 [animation-duration:3s]" />

          {NODES.map(({ id, pos, ...node }) => (
            <div key={id} className={`absolute ${pos}`}>
              <Node {...node} testId={`ecosystem-node-${id}`} />
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center gap-4 md:hidden" data-testid="ecosystem-diagram-mobile">
          <div className="flex h-24 w-24 flex-col items-center justify-center rounded-3xl bg-[#0F4D3F]">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#C6F04A] p-1.5">
              <img src="/t-dark.png" alt="" className="h-full w-auto" />
            </span>
            <span className="mt-1.5 text-xs font-extrabold tracking-[0.2em] text-[#F3EBD7]">TUPU</span>
          </div>
          <div aria-hidden className="h-6 w-px bg-[#0F4D3F]/30" />
          {NODES.map(({ id, ...node }) => (
            <Node key={id} {...node} testId={`ecosystem-node-mobile-${id}`} />
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
